import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',            to: '/'           },
  { label: 'Services',        to: '/services'   },
  { label: 'Industries',      to: '/industries' },
  { label: 'Portfolio',       to: '/portfolio'  },
  { label: 'About',           to: '/about'      },
  { label: 'Contact',         to: '/contact'    },
];

const SOCIAL = [
  { icon: 'fab fa-linkedin-in', href: '#',                             label: 'LinkedIn'  },
  { icon: 'fab fa-twitter',     href: '#',                             label: 'Twitter'   },
  { icon: 'fab fa-facebook-f',  href: '#',                             label: 'Facebook'  },
  { icon: 'fab fa-whatsapp',    href: 'https://wa.me/256702499649',    label: 'WhatsApp'  },
];

function Footer() {
  return (
    <footer className="footer-corporate">
      <div className="container">

        <div className="footer-top">
          <div className="row align-items-start g-4">

            {/* Brand */}
            <div className="col-lg-4 col-md-12">
              <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', textDecoration: 'none' }}>
                <img
                  src="/logo-white.png"
                  alt="Salama Consult"
                  style={{ height: 30, width: 'auto', objectFit: 'contain' }}
                  onError={e => { e.target.style.display = 'none'; }}
                />

              </Link>
              <p className="footer-tagline">
                We build and run the systems that keep your organisation running — based in Kampala, serving East Africa and beyond.
              </p>
              <div className="footer-social">
                {SOCIAL.map(s => (
                  <a key={s.label} href={s.href} aria-label={s.label} target="_blank" rel="noopener noreferrer">
                    <i className={s.icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Links */}
            <div className="col-lg-3 col-md-4 col-6">
              <div className="footer-col-title">Navigate</div>
              <ul className="footer-links-list">
                {NAV_LINKS.map(l => (
                  <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-5 col-md-8">
              <div className="footer-col-title">Get in Touch</div>
              <ul className="footer-links-list">
                <li style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.83rem', display: 'flex', alignItems: 'flex-start', gap: '0.6rem' }}>
                  <i className="fas fa-map-marker-alt" style={{ marginTop: '0.2rem', width: 14 }} />
                  Kampala, Uganda
                </li>
                <li style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.83rem', display: 'flex', alignItems: 'flex-start', gap: '0.6rem' }}>
                  <i className="fas fa-phone" style={{ marginTop: '0.2rem', width: 14 }} />
                  +256 702 499 649 &nbsp;·&nbsp; +256 783 975 685
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                  <i className="fas fa-envelope" style={{ color: 'rgba(255,255,255,0.35)', width: 14 }} />
                  <a href="mailto:info@salamasystems.com">info@salamasystems.com</a>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                  <i className="fas fa-headset" style={{ color: 'rgba(255,255,255,0.35)', width: 14 }} />
                  <a href="mailto:support@salamasystems.com">support@salamasystems.com</a>
                </li>
                <li style={{ marginTop: '0.75rem' }}>
                  <a
                    href="https://wa.me/256702499649?text=Hello%20Salama%20Consult"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      background: '#25D366',
                      color: '#fff',
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      padding: '0.45rem 1rem',
                      borderRadius: 6,
                      textDecoration: 'none',
                    }}
                  >
                    <i className="fab fa-whatsapp" />
                    WhatsApp Us
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            &copy; {new Date().getFullYear()} Salama Consult Limited. All rights reserved.
          </span>
          <div className="footer-legal">
            <Link to="/contact">Privacy</Link>
            <span className="footer-legal-sep" />
            <Link to="/contact">Terms</Link>
            <span className="footer-legal-sep" />
            <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.77rem' }}>
              <i className="fas fa-globe me-1" />Uganda
            </span>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
